module.exports = __webpack_public_path__ + "img/ucloud.a052f7cc.svg";